import React from 'react';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import useBreakpoints from '../../utilities/useBreakpoints';
import { useNavigate } from 'react-router-dom';
import permissionsProvider from '../../utilities/permissionsProvider';

const DashboardHeader = ({
    navigateUrl
}) => {

    const { isBreakpoint } = useBreakpoints();
    const addCustomerUrl = '/customers/edit/0';
    const changeView = useNavigate();

    return (
        <div className="dashboard-container dashboard-nav">
            <Col>
                {isBreakpoint('sm') ? (
                    <Row className="align-items-end">
                        {permissionsProvider.isMinUser('Manager') &&
                            <Col xs="auto">
                                <div className="action-button"
                                    onClick={() => navigateUrl(addCustomerUrl)}
                                >
                                    <img src="/images/add-customer.svg" style={{ height: '32px' }} />
                                </div>
                            </Col>
                        }
                        <Col>
                        </Col>
                        <Col xs="auto">
                            <Button onClick={() => changeView('/')} variant="info">
                                QUICK SEARCH
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button onClick={() => changeView('/dashboard/customers')} variant="info">
                                CUSTOMERS
                            </Button>
                        </Col>
                        <Col xs="auto">
                            <Button onClick={() => changeView('/dashboard/jobs')} variant="info" >
                                JOBS
                            </Button>
                        </Col>
                    </Row>
                    ) : (
                <Row>
                    <div className="left-nav">
                        {permissionsProvider.isMinUser('Manager') &&
                            <a className="action-button"
                                onClick={() => navigateUrl(addCustomerUrl)}>ADD CUSTOMER
                            </a>
                        }
                        <a className="action-button"
                            onClick={() => changeView('/')}>QUICK SEARCH
                        </a>
                        <a className="action-button"
                            onClick={() => changeView('/dashboard/customers')}>CUSTOMERS
                        </a>
                        <a className="action-button"
                            onClick={() => changeView('/dashboard/jobs')}>JOBS
                        </a>
                    </div>
                </Row>
                    )}
            </Col>
        </div>
    );
}

export default DashboardHeader;